module.exports = __webpack_public_path__ + "img/ico_plate.dc322d11.png";